module.exports = __webpack_public_path__ + "static/media/mercury-1.23c1c09d.jpg";